import { render, staticRenderFns } from "./CSideMenu.vue?vue&type=template&id=1a850c2f"
import script from "./CSideMenu.vue?vue&type=script&lang=js"
export * from "./CSideMenu.vue?vue&type=script&lang=js"
import style0 from "./CSideMenu.vue?vue&type=style&index=0&id=1a850c2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports